// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-heading p {
    font: normal normal 600 20px/23px Poppins;
    letter-spacing: 0px;
    color: #333333;
}

.cart-heading h6 {
    font: normal normal normal 14px/10px Poppins;
    letter-spacing: 0px;
    color: #9D9D9D;
}

.cart_area {
    padding: 4rem 0 0;
}

.cart-box-section {
    border: 1px solid #DFDFDF;
    border-radius: 8px;
    padding: 30px;
}

.cart-wrap {
    padding: 2rem 0 2rem;
}

.cart-count-row {
    display: flex;
    align-items: center;
    gap: 15px;
}

.cart-image img {
    width: 130px;
    object-fit: contain;
    height: 100px;
}

.name-of-product p {
    font: normal normal normal 15px/15px Poppins;
    letter-spacing: 0px;
    color: #404040;
    opacity: 1;
}

.name-of-product h6 {
    font: normal normal normal 14px/20px Poppins;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    font-weight: 600;
}

.name-of-product span {
    font: normal normal normal 14px/15px Poppins;
    letter-spacing: 0px;
    color: #8C8C8C;
}

/* increasing-decresing button */

.cart-image-section-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

@media (max-width: 700px) {
    .cart-image-section-row {
        display: block;
    }

    .adding-cart-row {
        padding: 2rem 0 2rem;
    }
}


.value-button {
    display: inline-block;
    border: 1px solid #ddd;
    margin: 0px;
    width: 40px;
    height: 40px;
    text-align: center;
    vertical-align: middle;
    padding: 11px 0;
    background: #eee;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
}

.value-button:hover {
    cursor: pointer;
}

form #decrease {
    margin-right: -4px;
    border-radius: 8px 0 0 8px;
}

form #increase {
    margin-left: -4px;
    border-radius: 0 8px 8px 0;
}

form #input-wrap {
    margin: 0px;
    padding: 0px;
}

input#number {
    text-align: center;
    border: none;
    margin: 0px;
    width: 40px;
    height: 40px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.cart-image-section-gap {
    gap: 10px;
}

.adding-cart-row form {
    display: inline-flex;
}

/*  */
.popup-animation-wrapp {
    height: 300px;
    position: relative;
    width: 423px;
    margin: auto;
}

.celebrationanimation {
    width: 100%;
    height: 100%;
    position: absolute;
}

.coinanimation {
    width: 100%;
    height: 100%;
    z-index: 5;
    position: relative;
}

.popup-animationimg-wrapp {
    position: relative;
    height: 100%;
    width: 100%;
}

.coincounshow {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9;
    top: 60%;
}

.cartitemimg {
    width: 125px;
    height: 90px;
}

.ok-btn {
    background: #ffd943 0% 0% no-repeat padding-box;
    padding: 10px 8px;
    width: 100px;
    border: 0;
    border-radius: 5px;
}

.cart-itemcount-section {
    display: flex;
    gap: 10px;
}

@media (max-width: 475px) {
    .popup-animation-wrapp {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/cart/cart.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;IACnB,cAAc;AAClB;;AAEA,gCAAgC;;AAEhC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;;AAGA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;IAIzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA,KAAK;AACL;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".cart-heading p {\n    font: normal normal 600 20px/23px Poppins;\n    letter-spacing: 0px;\n    color: #333333;\n}\n\n.cart-heading h6 {\n    font: normal normal normal 14px/10px Poppins;\n    letter-spacing: 0px;\n    color: #9D9D9D;\n}\n\n.cart_area {\n    padding: 4rem 0 0;\n}\n\n.cart-box-section {\n    border: 1px solid #DFDFDF;\n    border-radius: 8px;\n    padding: 30px;\n}\n\n.cart-wrap {\n    padding: 2rem 0 2rem;\n}\n\n.cart-count-row {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.cart-image img {\n    width: 130px;\n    object-fit: contain;\n    height: 100px;\n}\n\n.name-of-product p {\n    font: normal normal normal 15px/15px Poppins;\n    letter-spacing: 0px;\n    color: #404040;\n    opacity: 1;\n}\n\n.name-of-product h6 {\n    font: normal normal normal 14px/20px Poppins;\n    letter-spacing: 0px;\n    color: #000000;\n    opacity: 1;\n    font-weight: 600;\n}\n\n.name-of-product span {\n    font: normal normal normal 14px/15px Poppins;\n    letter-spacing: 0px;\n    color: #8C8C8C;\n}\n\n/* increasing-decresing button */\n\n.cart-image-section-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@media (max-width: 700px) {\n    .cart-image-section-row {\n        display: block;\n    }\n\n    .adding-cart-row {\n        padding: 2rem 0 2rem;\n    }\n}\n\n\n.value-button {\n    display: inline-block;\n    border: 1px solid #ddd;\n    margin: 0px;\n    width: 40px;\n    height: 40px;\n    text-align: center;\n    vertical-align: middle;\n    padding: 11px 0;\n    background: #eee;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.value-button:hover {\n    cursor: pointer;\n}\n\nform #decrease {\n    margin-right: -4px;\n    border-radius: 8px 0 0 8px;\n}\n\nform #increase {\n    margin-left: -4px;\n    border-radius: 0 8px 8px 0;\n}\n\nform #input-wrap {\n    margin: 0px;\n    padding: 0px;\n}\n\ninput#number {\n    text-align: center;\n    border: none;\n    margin: 0px;\n    width: 40px;\n    height: 40px;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.cart-image-section-gap {\n    gap: 10px;\n}\n\n.adding-cart-row form {\n    display: inline-flex;\n}\n\n/*  */\n.popup-animation-wrapp {\n    height: 300px;\n    position: relative;\n    width: 423px;\n    margin: auto;\n}\n\n.celebrationanimation {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n}\n\n.coinanimation {\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n    position: relative;\n}\n\n.popup-animationimg-wrapp {\n    position: relative;\n    height: 100%;\n    width: 100%;\n}\n\n.coincounshow {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 9;\n    top: 60%;\n}\n\n.cartitemimg {\n    width: 125px;\n    height: 90px;\n}\n\n.ok-btn {\n    background: #ffd943 0% 0% no-repeat padding-box;\n    padding: 10px 8px;\n    width: 100px;\n    border: 0;\n    border-radius: 5px;\n}\n\n.cart-itemcount-section {\n    display: flex;\n    gap: 10px;\n}\n\n@media (max-width: 475px) {\n    .popup-animation-wrapp {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
